// @ts-nocheck
import { types } from 'mobx-state-tree';
import moment from 'moment-timezone';

import DateTime from '@utils/mst/types/DateTime';

import { isAValidDate } from '@utils/dates';
import { DEFAULT_GROUP_ID } from '@utils/mst/organizationalHelpers';
import Organization from './Organization';

const MetaData = types.model('MetaData', {
  customMemberType: types.optional(types.boolean, false),
  shareable: types.maybeNull(types.boolean),
  audience: types.maybeNull(types.string),
});

const AccessCode = types
  .model('AccessCode', {
    id: types.identifierNumber,
    activatedAt: types.maybeNull(DateTime),
    benefitsUrl: types.maybeNull(types.string),
    code: types.string,
    duration: types.maybeNull(types.number),
    expiredAt: types.maybeNull(DateTime),
    isEligibilityCode: types.maybeNull(types.boolean),
    limit: types.maybeNull(types.number),
    metaData: types.maybeNull(MetaData),
    organization: types.reference(Organization),
    organizationalGroups: types.optional(types.number, DEFAULT_GROUP_ID),
    orgGroupId: types.maybeNull(types.number),
    defaultOrganizationalGroup: types.maybeNull(types.frozen()),
  })
  .views((self) => ({
    get activatedAtMoment() {
      if (!isAValidDate(self.activatedAt)) return null;

      return moment(self.activatedAt).format('MM-DD-YYYY');
    },

    get expiredAtMoment() {
      if (!isAValidDate(self.expiredAt)) return null;

      return moment(self.expiredAt).format('MM-DD-YYYY');
    },

    get hasCustomMemberType() {
      return Boolean(self.metaData?.customMemberType);
    },

    get isPPI() {
      return self.metaData?.audience?.includes('ppi') && self.metaData?.shareable === true;
    },

    get hasKKRCustomMemberType() {
      return self.hasCustomMemberType && self.organization.name.includes('KKR');
    },

    get effectiveOrgGroupId() {
      return self.orgGroupId || self.organizationalGroups;
    },

    get organizationalGroupName() {
      if (self.defaultOrganizationalGroup?.name) {
        return self.defaultOrganizationalGroup.name;
      }
      return null;
    },
  }))
  .actions((self) => ({
    setOrganizationalGroups(groupId: number) {
      self.organizationalGroups = groupId;
    },

    setOrgGroupId(groupId: number) {
      self.orgGroupId = groupId;
    },
  }));

export default AccessCode;
